import _asyncToGenerator from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { env, util } from '@tensorflow/tfjs-core';
import { getWebGLContext, setWebGLContext } from './canvas_util';
import * as gpgpu_util from './gpgpu_util';
import * as tex_util from './tex_util';
import * as webgl_util from './webgl_util';
export var GPGPUContext = /*#__PURE__*/function () {
  function GPGPUContext(gl) {
    _classCallCheck(this, GPGPUContext);
    this.outputTexture = null;
    this.program = null;
    this.disposed = false;
    this.itemsToPoll = [];
    var glVersion = env().getNumber('WEBGL_VERSION');
    if (gl != null) {
      this.gl = gl;
      setWebGLContext(glVersion, gl);
    } else {
      this.gl = getWebGLContext(glVersion);
    }
    gl = this.gl;
    if (env().getNumber('WEBGL_VERSION') === 2) {
      var gl2 = gl;
      this.createVertexArray = function () {
        return webgl_util.callAndCheck(gl2, function () {
          return gl2.createVertexArray();
        });
      };
      this.bindVertexArray = function (vao) {
        return webgl_util.callAndCheck(gl2, function () {
          return gl2.bindVertexArray(vao);
        });
      };
      this.deleteVertexArray = function (vao) {
        return webgl_util.callAndCheck(gl2, function () {
          return gl2.deleteVertexArray(vao);
        });
      };
      this.getVertexArray = function () {
        return webgl_util.callAndCheck(gl2, function () {
          return gl2.getParameter(gl2.VERTEX_ARRAY_BINDING);
        });
      };
    } else if (gl != null) {
      var ext = gl.getExtension('OES_vertex_array_object');
      if (ext == null) {
        throw new Error('All WebGL1 implementations are expected to offer' + ' OES_vertex_array_object.');
      }
      this.createVertexArray = function () {
        return webgl_util.callAndCheck(gl, function () {
          return ext.createVertexArrayOES();
        });
      };
      this.bindVertexArray = function (vao) {
        return webgl_util.callAndCheck(gl, function () {
          return ext.bindVertexArrayOES(vao);
        });
      };
      this.deleteVertexArray = function (vao) {
        return webgl_util.callAndCheck(gl, function () {
          return ext.deleteVertexArrayOES(vao);
        });
      };
      this.getVertexArray = function () {
        return webgl_util.callAndCheck(gl, function () {
          return gl.getParameter(ext.VERTEX_ARRAY_BINDING_OES);
        });
      };
    }
    // WebGL 2.0 enables texture floats without an extension.
    var COLOR_BUFFER_FLOAT = 'WEBGL_color_buffer_float';
    var COLOR_BUFFER_HALF_FLOAT = 'EXT_color_buffer_half_float';
    this.parallelCompilationExtension = this.gl.getExtension('KHR_parallel_shader_compile');
    if (env().getNumber('WEBGL_VERSION') === 1) {
      var TEXTURE_FLOAT = 'OES_texture_float';
      var TEXTURE_HALF_FLOAT = 'OES_texture_half_float';
      this.textureFloatExtension = webgl_util.getExtensionOrThrow(this.gl, TEXTURE_FLOAT);
      if (webgl_util.hasExtension(this.gl, TEXTURE_HALF_FLOAT)) {
        this.textureHalfFloatExtension = webgl_util.getExtensionOrThrow(this.gl, TEXTURE_HALF_FLOAT);
      } else if (env().get('WEBGL_FORCE_F16_TEXTURES')) {
        throw new Error('GL context does not support half float textures, yet the ' + 'environment flag WEBGL_FORCE_F16_TEXTURES is set to true.');
      }
      this.colorBufferFloatExtension = this.gl.getExtension(COLOR_BUFFER_FLOAT);
      if (webgl_util.hasExtension(this.gl, COLOR_BUFFER_HALF_FLOAT)) {
        this.colorBufferHalfFloatExtension = webgl_util.getExtensionOrThrow(this.gl, COLOR_BUFFER_HALF_FLOAT);
      } else if (env().get('WEBGL_FORCE_F16_TEXTURES')) {
        throw new Error('GL context does not support color renderable half floats, yet ' + 'the environment flag WEBGL_FORCE_F16_TEXTURES is set to true.');
      }
    } else {
      COLOR_BUFFER_FLOAT = 'EXT_color_buffer_float';
      if (webgl_util.hasExtension(this.gl, COLOR_BUFFER_FLOAT)) {
        this.colorBufferFloatExtension = this.gl.getExtension(COLOR_BUFFER_FLOAT);
      } else if (webgl_util.hasExtension(this.gl, COLOR_BUFFER_HALF_FLOAT)) {
        this.colorBufferHalfFloatExtension = this.gl.getExtension(COLOR_BUFFER_HALF_FLOAT);
      } else {
        throw new Error('GL context does not support color renderable floats');
      }
    }
    this.vertexBuffer = gpgpu_util.createVertexBuffer(this.gl);
    this.indexBuffer = gpgpu_util.createIndexBuffer(this.gl);
    this.framebuffer = webgl_util.createFramebuffer(this.gl);
    this.textureConfig = tex_util.getTextureConfig(this.gl, this.textureHalfFloatExtension);
  }
  _createClass(GPGPUContext, [{
    key: "dispose",
    value: function dispose() {
      var _this = this;
      if (this.disposed) {
        return;
      }
      if (this.program != null) {
        console.warn('Disposing a GPGPUContext that still has a bound WebGLProgram.' + ' This is probably a resource leak, delete the program with ' + 'GPGPUContext.deleteProgram before disposing.');
      }
      if (this.outputTexture != null) {
        console.warn('Disposing a GPGPUContext that still has a bound output matrix ' + 'texture.  This is probably a resource leak, delete the output ' + 'matrix texture with GPGPUContext.deleteMatrixTexture before ' + 'disposing.');
      }
      var gl = this.gl;
      webgl_util.callAndCheck(gl, function () {
        return gl.finish();
      });
      webgl_util.callAndCheck(gl, function () {
        return gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      });
      webgl_util.callAndCheck(gl, function () {
        return gl.deleteFramebuffer(_this.framebuffer);
      });
      webgl_util.callAndCheck(gl, function () {
        return gl.bindBuffer(gl.ARRAY_BUFFER, null);
      });
      webgl_util.callAndCheck(gl, function () {
        return gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
      });
      webgl_util.callAndCheck(gl, function () {
        return gl.deleteBuffer(_this.indexBuffer);
      });
      this.disposed = true;
    }
  }, {
    key: "createFloat32MatrixTexture",
    value: function createFloat32MatrixTexture(rows, columns) {
      this.throwIfDisposed();
      return gpgpu_util.createFloat32MatrixTexture(this.gl, rows, columns, this.textureConfig);
    }
  }, {
    key: "createFloat16MatrixTexture",
    value: function createFloat16MatrixTexture(rows, columns) {
      this.throwIfDisposed();
      return gpgpu_util.createFloat16MatrixTexture(this.gl, rows, columns, this.textureConfig);
    }
  }, {
    key: "createUnsignedBytesMatrixTexture",
    value: function createUnsignedBytesMatrixTexture(rows, columns) {
      this.throwIfDisposed();
      return gpgpu_util.createUnsignedBytesMatrixTexture(this.gl, rows, columns, this.textureConfig);
    }
  }, {
    key: "uploadPixelDataToTexture",
    value: function uploadPixelDataToTexture(texture, pixels) {
      this.throwIfDisposed();
      gpgpu_util.uploadPixelDataToTexture(this.gl, texture, pixels);
    }
  }, {
    key: "uploadDenseMatrixToTexture",
    value: function uploadDenseMatrixToTexture(texture, width, height, data) {
      this.throwIfDisposed();
      gpgpu_util.uploadDenseMatrixToTexture(this.gl, texture, width, height, data, this.textureConfig);
    }
  }, {
    key: "createFloat16PackedMatrixTexture",
    value: function createFloat16PackedMatrixTexture(rows, columns) {
      this.throwIfDisposed();
      return gpgpu_util.createFloat16PackedMatrixTexture(this.gl, rows, columns, this.textureConfig);
    }
  }, {
    key: "createPackedMatrixTexture",
    value: function createPackedMatrixTexture(rows, columns) {
      this.throwIfDisposed();
      return gpgpu_util.createPackedMatrixTexture(this.gl, rows, columns, this.textureConfig);
    }
  }, {
    key: "deleteMatrixTexture",
    value: function deleteMatrixTexture(texture) {
      var _this2 = this;
      this.throwIfDisposed();
      if (this.outputTexture === texture) {
        webgl_util.unbindColorTextureFromFramebuffer(this.gl, this.framebuffer);
        this.outputTexture = null;
      }
      webgl_util.callAndCheck(this.gl, function () {
        return _this2.gl.deleteTexture(texture);
      });
    }
  }, {
    key: "downloadByteEncodedFloatMatrixFromOutputTexture",
    value: function downloadByteEncodedFloatMatrixFromOutputTexture(texture, rows, columns) {
      var _this3 = this;
      return this.downloadMatrixDriver(texture, function () {
        return gpgpu_util.downloadByteEncodedFloatMatrixFromOutputTexture(_this3.gl, rows, columns, _this3.textureConfig);
      });
    }
  }, {
    key: "downloadPackedMatrixFromBuffer",
    value: function downloadPackedMatrixFromBuffer(buffer, batch, rows, columns, physicalRows, physicalCols) {
      return gpgpu_util.downloadPackedMatrixFromBuffer(this.gl, buffer, batch, rows, columns, physicalRows, physicalCols, this.textureConfig);
    }
  }, {
    key: "downloadFloat32MatrixFromBuffer",
    value: function downloadFloat32MatrixFromBuffer(buffer, size) {
      return gpgpu_util.downloadFloat32MatrixFromBuffer(this.gl, buffer, size);
    }
  }, {
    key: "createBufferFromTexture",
    value: function createBufferFromTexture(texture, rows, columns) {
      this.bindTextureToFrameBuffer(texture);
      var result = gpgpu_util.createBufferFromOutputTexture(this.gl, rows, columns, this.textureConfig);
      this.unbindTextureToFrameBuffer();
      return result;
    }
  }, {
    key: "createAndWaitForFence",
    value: function createAndWaitForFence() {
      var fenceContext = this.createFence(this.gl);
      return this.pollFence(fenceContext);
    }
  }, {
    key: "createFence",
    value: function createFence(gl) {
      var _this4 = this;
      var query;
      var isFencePassed;
      if (env().getBool('WEBGL_FENCE_API_ENABLED')) {
        var gl2 = gl;
        var sync = gl2.fenceSync(gl2.SYNC_GPU_COMMANDS_COMPLETE, 0);
        gl.flush();
        isFencePassed = function isFencePassed() {
          var status = gl2.clientWaitSync(sync, 0, 0);
          return status === gl2.ALREADY_SIGNALED || status === gl2.CONDITION_SATISFIED;
        };
        query = sync;
      } else if (env().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') > 0) {
        query = this.beginQuery();
        this.endQuery();
        isFencePassed = function isFencePassed() {
          return _this4.isQueryAvailable(query, env().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION'));
        };
      } else {
        // If we have no way to fence, return true immediately. This will fire in
        // WebGL 1.0 when there is no disjoint query timer. In this case, because
        // the fence passes immediately, we'll immediately ask for a download of
        // the texture, which will cause the UI thread to hang.
        isFencePassed = function isFencePassed() {
          return true;
        };
      }
      return {
        query: query,
        isFencePassed: isFencePassed
      };
    }
  }, {
    key: "downloadMatrixFromPackedTexture",
    value: function downloadMatrixFromPackedTexture(texture, physicalRows, physicalCols) {
      var _this5 = this;
      return this.downloadMatrixDriver(texture, function () {
        return gpgpu_util.downloadMatrixFromPackedOutputTexture(_this5.gl, physicalRows, physicalCols);
      });
    }
  }, {
    key: "createProgram",
    value: function createProgram(fragmentShader) {
      var _this6 = this;
      this.throwIfDisposed();
      var gl = this.gl;
      if (this.vertexShader == null) {
        this.vertexShader = gpgpu_util.createVertexShader(gl);
      }
      var program = webgl_util.createProgram(gl);
      webgl_util.callAndCheck(gl, function () {
        return gl.attachShader(program, _this6.vertexShader);
      });
      webgl_util.callAndCheck(gl, function () {
        return gl.attachShader(program, fragmentShader);
      });
      webgl_util.linkProgram(gl, program);
      var program2 = Object.assign(program, {
        vao: this.createVertexArray()
      });
      if (this.debug) {
        webgl_util.validateProgram(gl, program2);
      }
      return program2;
    }
  }, {
    key: "buildVao",
    value: function buildVao(program) {
      var _this7 = this;
      this.setProgram(program);
      this.bindVertexArray(program.vao);
      var gl = this.gl;
      // Bind index buffer, and vertex buffers based on program attrib
      // locations.
      webgl_util.callAndCheck(gl, function () {
        return gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, _this7.indexBuffer);
      });
      gpgpu_util.bindVertexProgramAttributeStreams(gl, program, this.vertexBuffer);
    }
  }, {
    key: "deleteProgram",
    value: function deleteProgram(program) {
      var _this8 = this;
      this.throwIfDisposed();
      if (program === this.program) {
        this.program = null;
      }
      if (program != null) {
        webgl_util.callAndCheck(this.gl, function () {
          return _this8.gl.deleteProgram(program);
        });
        this.deleteVertexArray(program.vao);
      }
    }
  }, {
    key: "setProgram",
    value: function setProgram(program) {
      var _this9 = this;
      this.throwIfDisposed();
      this.program = program;
      if (this.program != null) {
        if (this.debug) {
          webgl_util.validateProgram(this.gl, this.program);
        }
      }
      webgl_util.callAndCheck(this.gl, function () {
        return _this9.gl.useProgram(program);
      });
    }
  }, {
    key: "getUniformLocation",
    value: function getUniformLocation(program, uniformName) {
      var shouldThrow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      this.throwIfDisposed();
      if (shouldThrow) {
        return webgl_util.getProgramUniformLocationOrThrow(this.gl, program, uniformName);
      } else {
        return webgl_util.getProgramUniformLocation(this.gl, program, uniformName);
      }
    }
  }, {
    key: "getAttributeLocation",
    value: function getAttributeLocation(program, attribute) {
      var _this10 = this;
      this.throwIfDisposed();
      return webgl_util.callAndCheck(this.gl, function () {
        return _this10.gl.getAttribLocation(program, attribute);
      });
    }
  }, {
    key: "getUniformLocationNoThrow",
    value: function getUniformLocationNoThrow(program, uniformName) {
      this.throwIfDisposed();
      return this.gl.getUniformLocation(program, uniformName);
    }
  }, {
    key: "setInputMatrixTexture",
    value: function setInputMatrixTexture(inputMatrixTexture, uniformLocation, textureUnit) {
      this.throwIfDisposed();
      this.throwIfNoProgram();
      webgl_util.bindTextureToProgramUniformSampler(this.gl, inputMatrixTexture, uniformLocation, textureUnit);
    }
  }, {
    key: "setOutputMatrixTexture",
    value: function setOutputMatrixTexture(outputMatrixTexture, rows, columns) {
      this.setOutputMatrixTextureDriver(outputMatrixTexture, columns, rows);
    }
  }, {
    key: "setOutputPackedMatrixTexture",
    value: function setOutputPackedMatrixTexture(outputPackedMatrixTexture, rows, columns) {
      this.throwIfDisposed();
      var _tex_util$getPackedMa = tex_util.getPackedMatrixTextureShapeWidthHeight(rows, columns),
        _tex_util$getPackedMa2 = _slicedToArray(_tex_util$getPackedMa, 2),
        width = _tex_util$getPackedMa2[0],
        height = _tex_util$getPackedMa2[1];
      this.setOutputMatrixTextureDriver(outputPackedMatrixTexture, width, height);
    }
  }, {
    key: "setOutputMatrixWriteRegion",
    value: function setOutputMatrixWriteRegion(startRow, numRows, startColumn, numColumns) {
      this.setOutputMatrixWriteRegionDriver(startColumn, startRow, numColumns, numRows);
    }
  }, {
    key: "setOutputPackedMatrixWriteRegion",
    value: function setOutputPackedMatrixWriteRegion(startRow, numRows, startColumn, numColumns) {
      throw new Error('setOutputPackedMatrixWriteRegion not implemented.');
    }
  }, {
    key: "debugValidate",
    value: function debugValidate() {
      if (this.program != null) {
        webgl_util.validateProgram(this.gl, this.program);
      }
      webgl_util.validateFramebuffer(this.gl);
    }
  }, {
    key: "executeProgram",
    value: function executeProgram() {
      this.throwIfDisposed();
      this.throwIfNoProgram();
      var gl = this.gl;
      if (this.debug) {
        var boundVao = this.getVertexArray();
        console.assert(boundVao === this.program.vao, 'VAO changed between setProgram and executeProgram!');
        this.debugValidate();
      }
      webgl_util.callAndCheck(gl, function () {
        return gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0);
      });
    }
  }, {
    key: "blockUntilAllProgramsCompleted",
    value: function blockUntilAllProgramsCompleted() {
      var _this11 = this;
      this.throwIfDisposed();
      webgl_util.callAndCheck(this.gl, function () {
        return _this11.gl.finish();
      });
    }
  }, {
    key: "getQueryTimerExtension",
    value: function getQueryTimerExtension() {
      if (this.disjointQueryTimerExtension == null) {
        this.disjointQueryTimerExtension = webgl_util.getExtensionOrThrow(this.gl, env().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') === 2 ? 'EXT_disjoint_timer_query_webgl2' : 'EXT_disjoint_timer_query');
      }
      return this.disjointQueryTimerExtension;
    }
  }, {
    key: "getQueryTimerExtensionWebGL2",
    value: function getQueryTimerExtensionWebGL2() {
      return this.getQueryTimerExtension();
    }
  }, {
    key: "getQueryTimerExtensionWebGL1",
    value: function getQueryTimerExtensionWebGL1() {
      return this.getQueryTimerExtension();
    }
  }, {
    key: "beginQuery",
    value: function beginQuery() {
      if (env().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') === 2) {
        var gl2 = this.gl;
        var _ext = this.getQueryTimerExtensionWebGL2();
        var _query = gl2.createQuery();
        gl2.beginQuery(_ext.TIME_ELAPSED_EXT, _query);
        return _query;
      }
      var ext = this.getQueryTimerExtensionWebGL1();
      var query = ext.createQueryEXT();
      ext.beginQueryEXT(ext.TIME_ELAPSED_EXT, query);
      return query;
    }
  }, {
    key: "endQuery",
    value: function endQuery() {
      if (env().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') === 2) {
        var gl2 = this.gl;
        var _ext2 = this.getQueryTimerExtensionWebGL2();
        gl2.endQuery(_ext2.TIME_ELAPSED_EXT);
        return;
      }
      var ext = this.getQueryTimerExtensionWebGL1();
      ext.endQueryEXT(ext.TIME_ELAPSED_EXT);
    }
  }, {
    key: "waitForQueryAndGetTime",
    value: function () {
      var _waitForQueryAndGetTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(query) {
        var _this12 = this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return util.repeatedTry(function () {
                return _this12.disposed ||
                // while testing contexts are created / disposed
                // in rapid succession, so without this check we
                // may poll for the query timer indefinitely
                _this12.isQueryAvailable(query, env().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION'));
              });
            case 2:
              return _context.abrupt("return", this.getQueryTime(query, env().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION')));
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function waitForQueryAndGetTime(_x) {
        return _waitForQueryAndGetTime.apply(this, arguments);
      }
      return waitForQueryAndGetTime;
    }()
  }, {
    key: "getQueryTime",
    value: function getQueryTime(query, queryTimerVersion) {
      if (queryTimerVersion === 0) {
        return null;
      }
      if (queryTimerVersion === 2) {
        var gl2 = this.gl;
        var timeElapsedNanos = gl2.getQueryParameter(query, gl2.QUERY_RESULT);
        // Return milliseconds.
        return timeElapsedNanos / 1000000;
      } else {
        var ext = this.getQueryTimerExtensionWebGL1();
        var _timeElapsedNanos = ext.getQueryObjectEXT(query, ext.QUERY_RESULT_EXT);
        // Return milliseconds.
        return _timeElapsedNanos / 1000000;
      }
    }
  }, {
    key: "isQueryAvailable",
    value: function isQueryAvailable(query, queryTimerVersion) {
      if (queryTimerVersion === 0) {
        return true;
      }
      if (queryTimerVersion === 2) {
        var gl2 = this.gl;
        var ext = this.getQueryTimerExtensionWebGL2();
        var available = gl2.getQueryParameter(query, gl2.QUERY_RESULT_AVAILABLE);
        if (this.disjoint == null) {
          this.disjoint = this.gl.getParameter(ext.GPU_DISJOINT_EXT);
        }
        return available && !this.disjoint;
      } else {
        var _ext3 = this.getQueryTimerExtensionWebGL1();
        var _available = _ext3.getQueryObjectEXT(query, _ext3.QUERY_RESULT_AVAILABLE_EXT);
        if (this.disjoint == null) {
          this.disjoint = this.gl.getParameter(_ext3.GPU_DISJOINT_EXT);
        }
        return _available && !this.disjoint;
      }
    }
  }, {
    key: "pollFence",
    value: function pollFence(fenceContext) {
      var _this13 = this;
      return new Promise(function (resolve) {
        _this13.addItemToPoll(function () {
          return fenceContext.isFencePassed();
        }, function () {
          return resolve();
        });
      });
    }
  }, {
    key: "pollItems",
    value: function pollItems() {
      // Find the last query that has finished.
      var index = linearSearchLastTrue(this.itemsToPoll.map(function (x) {
        return x.isDoneFn;
      }));
      for (var i = 0; i <= index; ++i) {
        var resolveFn = this.itemsToPoll[i].resolveFn;
        resolveFn();
      }
      this.itemsToPoll = this.itemsToPoll.slice(index + 1);
    }
  }, {
    key: "addItemToPoll",
    value: function addItemToPoll(isDoneFn, resolveFn) {
      var _this14 = this;
      this.itemsToPoll.push({
        isDoneFn: isDoneFn,
        resolveFn: resolveFn
      });
      if (this.itemsToPoll.length > 1) {
        // We already have a running loop that polls.
        return;
      }
      // Start a new loop that polls.
      var scheduleFn = undefined;
      if ('setTimeoutCustom' in env().platform) {
        scheduleFn = env().platform.setTimeoutCustom.bind(env().platform);
      }
      util.repeatedTry(function () {
        _this14.pollItems();
        // End the loop if no more items to poll.
        return _this14.itemsToPoll.length === 0;
      }, function () {
        return 0;
      }, null, scheduleFn);
    }
  }, {
    key: "bindTextureToFrameBuffer",
    value: function bindTextureToFrameBuffer(texture) {
      this.throwIfDisposed();
      webgl_util.bindColorTextureToFramebuffer(this.gl, texture, this.framebuffer);
      if (this.debug) {
        webgl_util.validateFramebuffer(this.gl);
      }
    }
  }, {
    key: "unbindTextureToFrameBuffer",
    value: function unbindTextureToFrameBuffer() {
      if (this.outputTexture != null) {
        webgl_util.bindColorTextureToFramebuffer(this.gl, this.outputTexture, this.framebuffer);
        if (this.debug) {
          webgl_util.validateFramebuffer(this.gl);
        }
      } else {
        webgl_util.unbindColorTextureFromFramebuffer(this.gl, this.framebuffer);
      }
    }
  }, {
    key: "downloadMatrixDriver",
    value: function downloadMatrixDriver(texture, downloadAndDecode) {
      this.bindTextureToFrameBuffer(texture);
      var result = downloadAndDecode();
      this.unbindTextureToFrameBuffer();
      return result;
    }
  }, {
    key: "setOutputMatrixTextureDriver",
    value: function setOutputMatrixTextureDriver(outputMatrixTextureMaybePacked, width, height) {
      this.throwIfDisposed();
      var gl = this.gl;
      webgl_util.bindColorTextureToFramebuffer(gl, outputMatrixTextureMaybePacked, this.framebuffer);
      if (this.debug) {
        webgl_util.validateFramebuffer(gl);
      }
      this.outputTexture = outputMatrixTextureMaybePacked;
      webgl_util.callAndCheck(gl, function () {
        return gl.viewport(0, 0, width, height);
      });
      webgl_util.callAndCheck(gl, function () {
        return gl.scissor(0, 0, width, height);
      });
    }
  }, {
    key: "setOutputMatrixWriteRegionDriver",
    value: function setOutputMatrixWriteRegionDriver(x, y, width, height) {
      var _this15 = this;
      this.throwIfDisposed();
      webgl_util.callAndCheck(this.gl, function () {
        return _this15.gl.scissor(x, y, width, height);
      });
    }
  }, {
    key: "throwIfDisposed",
    value: function throwIfDisposed() {
      if (this.disposed) {
        throw new Error('Attempted to use disposed GPGPUContext.');
      }
    }
  }, {
    key: "throwIfNoProgram",
    value: function throwIfNoProgram() {
      if (this.program == null) {
        throw new Error('No GPU program is currently set.');
      }
    }
  }, {
    key: "debug",
    get: function get() {
      return env().getBool('DEBUG');
    }
  }]);
  return GPGPUContext;
}();
/**
 * Finds the index of the last true element using linear search.
 * Note: We can't do binary search because Chrome expects us to explicitly
 * test all fences before download:
 * https://github.com/tensorflow/tfjs/issues/1145
 */
export function linearSearchLastTrue(arr) {
  var i = 0;
  for (; i < arr.length; ++i) {
    var isDone = arr[i]();
    if (!isDone) {
      break;
    }
  }
  return i - 1;
}